(function ($) {
    $(window).on('load', function () {
        if ($('.image-with-markers').length) {
            $('.image-with-markers .image-container').scrollLeft(($('.image-with-markers .image-container .background-image').width() - window.innerWidth) / 2)
        }
    })
    $('.image-with-markers .toggle div').on('click', function () {
        if ($(this).hasClass('active')) return;

        const status = $(this).data('side');
        $(this).addClass('active').siblings().removeClass('active');
        $('.image-with-markers .wrap').removeClass('active').filter(`[data-side="${$(this).data('side')}"]`).addClass('active');

    })
})(jQuery);